import { Pagination } from 'antd';
import type { PaginationProps } from 'antd';

export interface DPaginationProps extends PaginationProps {}

export const DarwinPagination = (props: DPaginationProps) => {
  return <Pagination {...props} />;
};
